module.exports = __webpack_public_path__ + "img/ic_english.f1788b25.svg";